import { DonationView } from '../view/donation-view';
import {Validator} from './validator';

export enum DonationValidity {
    VALID = 'VALID',
    REQUIRED = 'REQUIRED',
    MIN_REQUIRED = 'MIN_REQUIRED'
}
export class DonationValidator implements Validator {
    validate(amount: string,
        view?: DonationView,
        minimumDonation?: number,
        isBuilder?: boolean
        ): Promise<boolean> {
        if (minimumDonation && parseFloat(amount) < minimumDonation ) {
            if((isBuilder && view) || view){
                view.minDonationError();
            }
            return Promise.resolve(false);
        }

        if (parseFloat(amount) === 0) {
            if((isBuilder && view) || view){
                view.showError();
            }
            return Promise.resolve(false);
        }

        const validAmount = !!parseFloat(amount);
        if(!validAmount){
            if((isBuilder && view) || view){
                view.showError();
            }
            return Promise.resolve(false);
        }

        return Promise.resolve(validAmount);
    }
}
